// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2XtJS","container":"styles_container__1LH_6","title":"styles_title__2pOkN","wrapper":"styles_wrapper__1AwOD","answer":"styles_answer__23wc_"};